export default __webpack_public_path__ + "static/media/Green_Storeys_Tower_and_Floor_Plans.af04ee1a.pdf";